export default __webpack_public_path__ + "static/media/Letrero podio colorido.23e435e8.png";